import { State } from 'modules/data';

export function getPage<TPage>(state: State, pageId: string): TPage {
    return state.pages[pageId] as TPage;
}

export function getPageSafe<TPage>(state: State, pageId: string): TPage | undefined {
    return state.pages?.[pageId] as TPage | undefined;
}
